import "./App.css";
import { connect } from "react-redux";

import { authenticationAction } from "_actions";

import { useSelector } from "react-redux";
import { useDispatch } from "react-redux";
import Dashboard from "layouts/Dashboard";
import Auth from "layouts/Auth";
import { useEffect } from "react";
import SplashLayout from "layouts/SplashLayout";
import toast, { Toaster } from "react-hot-toast";
import i18n from "./i18n";
import ChatwoodWidget from "components/ChatwoodWidget";
import { SiteFeatures } from "config/siteFeatures";
/*
import { AwsRum } from "aws-rum-web";
try {
  const config = {
    sessionSampleRate: 1,
    guestRoleArn:
      "arn:aws:iam::654654213977:role/RUM-Monitor-eu-central-1-654654213977-6941088042171-Unauth",
    identityPoolId: "eu-central-1:623e6c17-c732-4099-8544-7bbbabf1b532",
    endpoint: "https://dataplane.rum.eu-central-1.amazonaws.com",
    telemetries: ["performance", "errors", "http"],
    allowCookies: true,
    enableXRay: true,
  };

  const APPLICATION_ID = "3348485c-10e5-48b7-8e98-f6daefedb158";
  const APPLICATION_VERSION = "1.0.0";
  const APPLICATION_REGION = "eu-central-1";

  const awsRum = new AwsRum(
    APPLICATION_ID,
    APPLICATION_VERSION,
    APPLICATION_REGION,
    config
  );
} catch (error) {
  // Ignore errors thrown during CloudWatch RUM web client initialization
}*/
function App(props) {

  useEffect(() => {
    const lang = localStorage.getItem("lang");
    if (!lang) {
      localStorage.setItem("lang", "en");
    }
  }, []);

  // RTL dilleri için dir attribute'unu güncelle
  useEffect(() => {
    const updateDir = (lang) => {
      // Arapça (ar) ve Kürtçe (krt) için RTL, diğerleri için LTR
      const rtlLanguages = ['ar', 'ku','krt'];
      const isRTL = rtlLanguages.includes(lang);
      document.documentElement.dir = isRTL ? 'rtl' : 'ltr';
      document.documentElement.lang = lang;
    };

    // İlk yüklemede mevcut dili kontrol et
    const currentLang = localStorage.getItem("lang") || i18n.language || "en";
    updateDir(currentLang);

    // Dil değişikliğini dinle
    const handleLanguageChange = (lang) => {
      updateDir(lang);
    };

    i18n.on('languageChanged', handleLanguageChange);

    return () => {
      i18n.off('languageChanged', handleLanguageChange);
    };
  }, []);

  // Mobil keyboard sorunları için global scroll kontrolü
  useEffect(() => {
    const preventBodyScroll = () => {
      // Body scroll'u engelle
      document.body.style.position = 'fixed';
      document.body.style.width = '100%';
      document.body.style.height = '100%';
      document.body.style.overflow = 'hidden';
    };

    const restoreBodyScroll = () => {
      // Body scroll'u geri yükle
      document.body.style.position = '';
      document.body.style.width = '';
      document.body.style.height = '';
      document.body.style.overflow = '';
    };

    const handleResize = () => {
      // Viewport değiştiğinde (keyboard açılıp kapanması)
      // Sadece gerçekten keyboard olayı ise scroll'u sıfırla
      setTimeout(() => {
        // Sadece body scroll'u varsa sıfırla (keyboard olayı)
        if (document.body.scrollTop > 0 || document.documentElement.scrollTop > 0) {
          window.scrollTo(0, 0);
          document.documentElement.scrollTop = 0;
          document.body.scrollTop = 0;
        }
      }, 100);
    };

    const handleFocusIn = (e) => {
      // Input focus olduğunda (keyboard açılacak)
      if (e.target.tagName === 'INPUT' || e.target.tagName === 'TEXTAREA') {
        // Login sayfasındaki input'ları global handling'den çıkar
        if (e.target.id === 'username' || e.target.id === 'password') {
          return; // Login input'ları için hiçbir şey yapma
        }
        
        // Diğer tüm input'lar için normal handling
        preventBodyScroll();
      }
    };

    const handleFocusOut = (e) => {
      // Input blur olduğunda (keyboard kapanacak)
      if (e.target.tagName === 'INPUT' || e.target.tagName === 'TEXTAREA') {
        // Login sayfasındaki input'ları global handling'den çıkar
        if (e.target.id === 'username' || e.target.id === 'password') {
          return; // Login input'ları için hiçbir şey yapma
        }
        
        // Diğer tüm input'lar için normal handling
        setTimeout(() => {
          restoreBodyScroll();
          handleResize();
        }, 300);
      }
    };

    // Event listener'ları ekle
    window.addEventListener('resize', handleResize);
    window.addEventListener('orientationchange', handleResize);
    document.addEventListener('focusin', handleFocusIn);
    document.addEventListener('focusout', handleFocusOut);

    // Cleanup
    return () => {
      window.removeEventListener('resize', handleResize);
      window.removeEventListener('orientationchange', handleResize);
      document.removeEventListener('focusin', handleFocusIn);
      document.removeEventListener('focusout', handleFocusOut);
      restoreBodyScroll();
    };
  }, []);
  //
  return (
    <div style={{ overflow: "hidden !important", backgroundImage: `url(${require('./assets/img/bg.jpg')})`, backgroundSize: "cover", backgroundPosition: "center", backgroundRepeat: "no-repeat" }} className="overflow-hidden relative appdiv">
      {props.authLoading ? (
        <SplashLayout />
      ) : (
        <>
          {props.loggedIn ? (
            <Dashboard />
          ) : (
            !SiteFeatures.CLOSED_SYSTEM ? <Dashboard /> : <Auth />
          )}
        </>
      )}
      <Toaster />
     {/* <ChatwoodWidget /> */}
    </div>
  );
}

const mapStateToProps = (state, props) => {
  const { authentication } = state;
  const { user, loggedIn, authLoading } = authentication;

  return {
    user,
    loggedIn,
    authLoading,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    UpdateUser: (user) => dispatch(authenticationAction.UpdateUser(user)),
    LoginSuccess: (user) => dispatch(authenticationAction.LoginSuccess(user)),
    LoginFailure: () => dispatch(authenticationAction.LoginFailure()),
    logout: () => dispatch(authenticationAction.logout()),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(App);
